class MacaronsWishlist {
  constructor() {
    try {
      const oldKey = 'onhow-wishlist';
      const newKey = 'macarons-wishlist';
      const oldVal = localStorage.getItem(oldKey);
      if (oldVal && !localStorage.getItem(newKey)) {
        localStorage.setItem(newKey, oldVal);
      }
    } catch (e) {}

    this.storage = {
      key: 'macarons-wishlist',
      get: () => JSON.parse(localStorage.getItem('macarons-wishlist') || '[]'),
      set: (items) => localStorage.setItem('macarons-wishlist', JSON.stringify(items))
    };

    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const toggleButton = e.target.closest('.macarons-wishlist-toggle');
      if (!toggleButton) return;

      e.preventDefault();
      this.toggleProduct(toggleButton);
    });

    this.updateButtons();
  }

  toggleProduct(button) {
const productData = {
  title: button.dataset.productTitle,
  image: button.dataset.productImg,
  price: button.dataset.productPrice,
  url: button.dataset.productUrl,
  variantId: button.dataset.variantId,
  personalization: button.dataset.personalization === 'true',
  personalizationLabel: button.dataset.personalizationLabel || '',
  personalizationRequired: button.dataset.personalizationRequired === 'true'
};

    let wishlist = this.storage.get();
    const index = wishlist.findIndex(item => item.title === productData.title);

    if (index === -1) {
      wishlist.push(productData);
      this.setButtonState(button, true);
    } else {
      wishlist.splice(index, 1);
      this.setButtonState(button, false);
    }

    this.storage.set(wishlist);
    this.updateWishlistCount();
  }

  setButtonState(button, isInWishlist) {
    const iconElement = button.querySelector('.macarons-wishlist-icon');
    const textElement = button.querySelector('.macarons-wishlist-text');

    if (isInWishlist) {
      button.classList.add('macarons-in-wishlist');
      if (iconElement) iconElement.classList.add('macarons-wishlist-active');
      if (textElement) textElement.textContent = 'In Wishlist';
    } else {
      button.classList.remove('macarons-in-wishlist');
      if (iconElement) iconElement.classList.remove('macarons-wishlist-active');
      if (textElement) textElement.textContent = 'Add to Wishlist';
    }
  }

  updateButtons() {
    const wishlist = this.storage.get();
    const buttons = document.querySelectorAll('.macarons-wishlist-toggle');

    buttons.forEach(button => {
      const productTitle = button.dataset.productTitle;
      const isInWishlist = wishlist.some(item => item.title === productTitle);
      this.setButtonState(button, isInWishlist);
    });

    this.updateWishlistCount();
  }

  updateWishlistCount() {
    const wishlist = this.storage.get();
    const countElements = document.querySelectorAll('.macarons-wishlist-count');

    countElements.forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length > 0 ? 'flex' : 'none';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!window.MacaronsWishlist) {
    window.MacaronsWishlist = new MacaronsWishlist();
  }
});